import { Button, DataSource, HorizontalSpacer, Label, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutHandlingRequirementXref extends Layout {
    buttonExpand: Button;
    horizontalspacerForTrailerType: HorizontalSpacer;
    labelCrossRef: Label;
    panelAccessorial: Panel;
    panelButtons: Panel;
    panelCollapsible: Panel;
    panelHeader: Panel;
    sourceEdiCrossRefHandlingRequirement: DataSource;
    tableCrossRef: Table;
}
